import { createCloudRunAxios } from './axios';

const remiApi = createCloudRunAxios('remi-api');

export interface ContactSavedSearch {
  id?: number;
  contact_id?: string;
  city?: string;
  state?: string;
  zipcode?: string | null;
  subdivision?: string;
  subdivisions?: string[];
  property_type?: string | null;
  propertysubtype?: string;
  min_price?: string | number | null;
  max_price?: string | number | null;
  bedrooms?: string | number | null;
  min_bedrooms?: string | number | null;
  max_bedrooms?: string | number | null;
  bathrooms?: string | number | null;
  min_bathrooms?: string | number | null;
  max_bathrooms?: string | number | null;
  status?: string[] | string | null;
  waterfront?: boolean | null;
  pool?: boolean | null;
  basement?: boolean | null;
  garage?: boolean | null;
  city_view?: boolean | null;
  mountain_view?: boolean | null;
  park_view?: boolean | null;
  water_view?: boolean | null;
  sqft_min?: string | number | null;
  sqft_max?: string | number | null;
  q?: string | null;
  schedule?: string | null;
  [key: string]: unknown;
}

/**
 * Schedule + delivery fields exposed by `POST /api/v1/ealert/profile`
 * after PR #2428 ("Fix eAlert profile Spanner fallback"). The endpoint
 * merges the legacy saved-search response with Spanner's eAlert profile
 * row, and hydrates `next_scheduled_at` from Cloud Tasks (or by adding
 * the cadence interval to `ealerts_last_execution` when the task lookup
 * misses). Surfacing these in the FE lets the follow-up plan card show
 * the contact's next eAlert send alongside the other planned touches.
 */
export interface EAlertProfileFields {
  ealerts_interval?: 'daily' | 'weekly' | 'bi-weekly' | 'biweekly' | string | null;
  ealerts_last_execution?: string | null;
  ealert_task_name?: string | null;
  next_scheduled_at?: string | null;
  next_schedule_source?: 'cloud_task' | 'inferred' | null;
  next_schedule_task_name?: string | null;
  registration_status?: string | null;
  delivery_health_status?: string | null;
  last_success_at?: string | null;
  last_execution_at?: string | null;
}

export type UserProfileResponse = ContactSavedSearch & EAlertProfileFields;

/**
 * Get user eAlert profile data
 * Uses POST /ealert/profile (not GET /get-user-profile which reads from legacy Firestore)
 */
export const getUserProfile = async (contactId: string, organizationId: string): Promise<UserProfileResponse> => {
  try {
    const response = await remiApi.post<UserProfileResponse>('/api/v1/ealert/profile', {
      contact_id: contactId,
      organization_id: organizationId,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};
